var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-layout"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('KTCodePreview',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"preview",fn:function(){return [_vm._t("form")]},proxy:true},{key:"foot",fn:function(){return [_vm._t("actions")]},proxy:true}],null,true)})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }